export class DsScroll {
  static to(elementId: string) {
    const el = document.getElementById(elementId);
    el?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }

  static isScrollable = (ele: HTMLElement) => {
    const hasScrollableContent = ele.scrollHeight > ele.clientHeight;

    const overflowYStyle = window.getComputedStyle(ele).overflowY;
    const isOverflowHidden = overflowYStyle.indexOf("hidden") !== -1;

    return hasScrollableContent && !isOverflowHidden;
  };

  static getScrollableParent = (ele: HTMLElement): HTMLElement => {
    return !ele || ele === document.body
      ? document.body
      : this.isScrollable(ele)
        ? ele
        : this.getScrollableParent(ele.parentNode as HTMLElement);
  };
}
